import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import entityPath from './entityPath';

type TopicTab = 'subtopics';

const TOPIC_PATH_TOPIC_FRAGMENT = gql(`
  fragment topicPath_topic on TopicFields {
    id
    name
  }
`);

const topicPath = (
  topic: DocumentType<typeof TOPIC_PATH_TOPIC_FRAGMENT>,
  tab?: TopicTab,
) => {
  const base = `/topics/${entityPath(topic.name, topic.id)}`;
  return tab ? `${base}/${tab}` : base;
};

const PUBLIC_TOPIC_PATH_TOPIC_FRAGMENT = gql(`
  fragment publicTopicPath_topic on TopicFields {
    ...topicPath_topic
  }
`);

export const publicTopicPath = (
  topic: DocumentType<typeof PUBLIC_TOPIC_PATH_TOPIC_FRAGMENT>,
) => `/public${topicPath(topic)}`;

export default topicPath;
